const { toHMS, toYMD } = require('@/functions/date');

// This file contains handler functions to be used to with dtQrCodeDirective that can be used to render QR codes.

/**
 * A default handler to simply return whatever is passed from the template in e.g. a bookingRef
 *
 * @param {*} data
 *
 * @returns {{content: *}}
 */
const defaultHandler = (data) => {
    return { content: data };
};

/**
 * Return a string composed of a prefix + YMDHMS.
 *
 * @returns {{content: string}}
 */
const insHandler = () => {
    const today = new Date();
    const prefix = '565';
    const ymd = toYMD(today).split('-').join('').substr(2, 6);
    const hms = toHMS(today).split(':').join('');
    const qrString = `${prefix}${ymd}${hms}`;
    return { content: qrString };
};

module.exports = {
    defaultHandler,
    insHandler,
};
